export default __webpack_public_path__ + "static/investment-image-7-607b1e73948e218b6a602b52e0ebde0a.jpg";